import { useQuery } from "@tanstack/react-query";
import { api } from "../api";
import { ErrorNote, Loading, Page } from "./common";

const CARD: React.CSSProperties = { background: "#fff", borderRadius: 3, boxShadow: "inset 0 0 0 1px rgba(0,0,0,.07)", padding: "14px 18px" };

// Parse the stored UTC instant and render it in the viewer's local zone.
function fmtWhen(iso: string | null): string {
  if (!iso) return "";
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? "" : d.toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" });
}

export function OnCall() {
  const { data, isLoading, error } = useQuery({ queryKey: ["oncall"], queryFn: api.oncall });
  if (isLoading) return <Loading />;
  if (error) return <ErrorNote error={error} />;
  const ring = data?.ring ?? [];
  const recent = data?.recent ?? [];
  return (
    <Page>
      <div>
        <h1 style={{ margin: 0, fontSize: 24, fontWeight: 600, letterSpacing: "-0.6px" }}>On-call &amp; emergency line</h1>
        <div style={{ fontSize: 14, color: "#8a8e88", marginTop: 3 }}>After-hours ring order and recent emergency contacts. Live paging runs through the softphone.</div>
      </div>

      <div style={CARD}>
        <div style={{ fontSize: 15, fontWeight: 600, marginBottom: 8 }}>Ring order</div>
        {ring.length === 0 ? (
          <div style={{ color: "#8a8e88", fontSize: 13 }}>No emergency ring steps configured yet.</div>
        ) : (
          ring.map((r) => (
            <div key={r.id} style={{ display: "flex", alignItems: "center", gap: 12, padding: "9px 0", borderTop: "1px solid #f4f3ee" }}>
              <span style={{ fontFamily: "'Space Mono',monospace", fontSize: 13, fontWeight: 700, color: "#006747", width: 22 }}>{r.position}</span>
              <span style={{ flex: 1, fontSize: 13, fontWeight: 500 }}>{r.target}</span>
              <span style={{ fontSize: 11.5, color: "#8a8e88" }}>rings {r.ringSeconds}s</span>
            </div>
          ))
        )}
      </div>

      <div style={CARD}>
        <div style={{ fontSize: 15, fontWeight: 600, marginBottom: 8 }}>Recent emergency contacts</div>
        {recent.length === 0 ? (
          <div style={{ color: "#8a8e88", fontSize: 13 }}>No emergency contacts recorded.</div>
        ) : (
          recent.map((r) => (
            <div key={r.id} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10, padding: "8px 0", borderTop: "1px solid #f4f3ee", fontSize: 12.5 }}>
              <span>{r.number ?? "Unknown number"}{r.ticketRef ? <span style={{ color: "#8a8e88", fontFamily: "'Space Mono',monospace" }}> · {r.ticketRef}</span> : null}</span>
              <span style={{ color: "#8a8e88" }}>{r.outcome ?? "—"}{r.at ? ` · ${fmtWhen(r.at)}` : ""}</span>
            </div>
          ))
        )}
      </div>
    </Page>
  );
}
